import { Tags } from 'packages/form/entities/legacy/question/Tags';
var questions = [
    {
        label: 'recruitment_presets.forms.general.education.title',
        type: 'select',
        subtype: null,
        validation_rule: ['required'],
        options: [
            {
                label: 'recruitment_presets.forms.general.education.options.over_5_years',
            },
            {
                label: 'recruitment_presets.forms.general.education.options.2-5_years',
            },
            {
                label: 'recruitment_presets.forms.general.education.options.under_2_years',
            },
            {
                label: 'recruitment_presets.forms.general.education.options.no_experience',
            },
        ],
    },
    {
        label: 'recruitment_presets.forms.general.expertise.title',
        type: 'select',
        subtype: 'multiple',
        validation_rule: ['required'],
        options: [
            {
                label: 'recruitment_presets.forms.general.expertise.option',
            },
            {
                label: 'recruitment_presets.forms.general.expertise.option',
            },
            {
                label: 'recruitment_presets.forms.general.expertise.option',
            },
        ],
    },
    {
        label: 'recruitment_presets.forms.default.questions.education.title',
        type: 'select',
        validation_rule: ['required'],
        options: [
            {
                label: 'recruitment_presets.forms.default.questions.education.option',
            },
            {
                label: 'recruitment_presets.forms.default.questions.education.option',
            },
            {
                label: 'recruitment_presets.forms.default.questions.education.option',
            },
            {
                label: 'recruitment_presets.forms.default.questions.education.option',
            },
        ],
    },
    {
        label: 'recruitment_presets.forms.general.contact_consent.title',
        type: 'select',
        subtype: null,
        attribute: 'jobilla::contact_consent',
        validation_rule: ['required'],
        options: [
            {
                label: 'recruitment_presets.forms.general.contact_consent.options.yes',
                position: 0,
                uuid: 'yes',
            },
            {
                label: 'recruitment_presets.forms.general.contact_consent.options.maybe',
                position: 1,
                uuid: 'maybe',
            },
            {
                label: 'recruitment_presets.forms.general.contact_consent.options.no',
                position: 2,
                uuid: 'no',
            },
        ],
    },
    {
        label: 'recruitment_presets.forms.general.name',
        type: 'text',
        attribute: 'jobilla::name',
        subtype: 'name',
        validation_rule: [
            'required',
        ],
        options: null,
    },
    {
        label: 'recruitment_presets.forms.general.email',
        type: 'text',
        attribute: 'jobilla::email',
        subtype: 'email',
        validation_rule: [
            'required',
            'email',
        ],
        options: null,
    },
    {
        label: 'recruitment_presets.forms.general.phone',
        type: 'text',
        attribute: 'jobilla::phone',
        subtype: 'phone',
        validation_rule: [
            'required',
        ],
        options: null,
    },
];
export var v3DefaultFormTemplate = {
    version: 3,
    send_button: {
        button_label: null,
    },
    questions: questions,
    results: [
        {
            type: 'final-screen',
        },
    ],
};
export var v2DefaultFormTemplate = {
    version: 2,
    questions: questions,
    results: [
        {
            type: 'final-screen',
        },
    ],
};
export var v1DefaultFormTemplate = {
    questions: [
        {
            position: 1,
            type: 'text',
            subtype: 'name',
            label: 'form.question_defaults.name',
            tags: { system: ['contact', 'respondent_name', Tags.PREFILL_CONFIGURABLE] },
            validationRule: ['required', 'single'],
        },
        {
            position: 2,
            type: 'select',
            label: 'form.question_defaults.previous_experience',
            options: [
                {
                    position: 1,
                    label: 'form.question_defaults.previous_experience_options.over_five_years',
                },
                {
                    position: 2,
                    label: 'form.question_defaults.previous_experience_options.two_to_five_years',
                },
                {
                    position: 3,
                    label: 'form.question_defaults.previous_experience_options.under_two_years',
                },
                {
                    position: 4,
                    label: 'form.question_defaults.previous_experience_options.no_experience',
                },
            ],
            validationRule: ['required'],
        },
        {
            position: 3,
            type: 'select',
            label: 'form.question_defaults.interested_in_company',
            options: [
                {
                    position: 1,
                    label: 'form.question_defaults.interested_in_company_options.yes',
                },
                {
                    position: 2,
                    label: 'form.question_defaults.interested_in_company_options.somewhat',
                },
                {
                    position: 3,
                    label: 'form.question_defaults.interested_in_company_options.no',
                },
            ],
            validationRule: ['required'],
        },
        {
            position: 4,
            type: 'text',
            subtype: 'email',
            label: 'form.question_defaults.email',
            tags: { system: ['contact', 'respondent_email', Tags.PREFILL_CONFIGURABLE] },
            validationRule: ['required', 'email', 'single'],
        },
        {
            position: 5,
            type: 'text',
            subtype: 'phone',
            label: 'form.question_defaults.phone',
            tags: { system: ['contact', 'respondent_phone'] },
            validationRule: ['required', 'phone', 'single'],
        },
    ],
    results: [
        {
            title: 'Result screen',
            description: 'Result description',
            type: 'final-screen',
        },
    ],
};
